import React, { FC } from 'react';
import styled from 'styled-components';
import AddToBasket from '@/src/components/AddToBasket';
import AddToWishlist from '@/src/components/AddToWishlist';

const StickyButtonsWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const AddToBasketWrapper = styled.div`
  flex-grow: 1;
`;

const AddToWishlistWrapper = styled.div`
  margin-left: 0.75rem;
`;

type StickyButtonsProps = {
  sku: string;
  isAvailable: boolean;
  /** function to force dimension selection */
  setHighlightUnselectedDimension: (setHighlight: boolean) => void;
  isSelected: boolean;
};

const StickyButtons: FC<StickyButtonsProps> = ({
  sku,
  setHighlightUnselectedDimension,
  isSelected,
}) => (
  <StickyButtonsWrapper>
    <AddToBasketWrapper data-testid="sticky-atb-button">
      <AddToBasket
        setHighlightUnselectedDimension={setHighlightUnselectedDimension}
        isSelected={isSelected}
      />
    </AddToBasketWrapper>
    <AddToWishlistWrapper data-testid="sticky-wishlist-button">
      <AddToWishlist sku={sku} showLabel={false} />
    </AddToWishlistWrapper>
  </StickyButtonsWrapper>
);
export default StickyButtons;
